import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const quagPowergrid10: IProductData = {
  id: "quag-powergrid-10",
  name: "Quagliardi Powergrid 10",
  description: "10 Slot 500 series chassis.",
  images: ["/img/quag_powergrid_10_front.jpg", "/img/quag_powergrid_10_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The POWERGRID 10 is a 10-slot chassis for series 500 equipment. 
It is equipped with an external switching power supply capable of delivering up to 2000mA of current per voltage rail.

On its rear panel, the POWERGRID 10 features accessible XLR and DB25 inputs and outputs, as well as ‘ground lift’ controls to prevent ground loops and ‘feed’ controls for easily daisy-chaining modules in adjacent slots to create channel strips without the need for additional cables.
`
  }, {
    label: "Specifications",
    markdown: `
- Voltages: +/-16VDC and +48VDC for phantom power
- Max Current: 2000mA total on +/-16VDC rails and 250mA on +48VDC
- Input Voltage: 100-240VAC, 50/60Hz, 120 Watts
- Weight: 4.2lb (Chassis) 1,1lb (PSU)
- Dimensions: 7.1 x 17.3 x 5.3 in (Chassis) / 7 x 3.5 x 2 in (PSU)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://quagliardiaudio.com/500-series-chassis/" target="_blank">https://quagliardiaudio.com/500-series-chassis/</a>
- <a to="https://drive.google.com/file/d/1K5K1q8nrV5bqr_NKKT7hG61_mdY8RVs7/view" target="_blank">Manual</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.CASES, HASHTAGS.RECORDING, HASHTAGS.MASTERING, HASHTAGS.MIXING],
    manufacturer: BRAND.QUAGLIARDI,
  }
}